import React, { useState} from 'react';
import { Search, Bell } from 'lucide-react';

import CONSTANTS from "../../Constants/Constants";
import LOGO_PLACEHOLDER from "../../LOGO_PLACEHOLDER.jpg";

const Type4Header = (props) => {

  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const {
      hasNewMessageFromParent,
      currentParentMessge,
      IS_DEBUG,
      bookingEngine,
      agentDetails,
      _company_name,
      _logo_url,
      PRODUCT_TYPES,
      isFlightPT,
      isStaysPT,
      isRentalCarsPT,
  } = props;

    const styles = {
      container: {
        backgroundColor: '#f8fafc',
        fontFamily: "'Inter', sans-serif",
        display: 'flex',
        flexDirection: 'column',
      },
      header: {
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e2e8f0',
        position: 'fixed',
        top: 0,
        /*zIndex: 50,*/
      },
      logoText: {
        background: 'linear-gradient(to right, #4f46e5, #7c3aed)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: 800,
        fontSize: '1.25rem',
      },
      searchContainer: {
        background: '#ffffff',
        borderBottom: '1px solid #e2e8f0',
        padding: '2rem 0',
      },
      searchBar: {
        background: '#f1f5f9',
        padding: '0.5rem',
        borderRadius: '1.25rem',
        border: '1px solid #e2e8f0',
      },
      searchItem: {
        background: '#ffffff',
        padding: '0.75rem 1rem',
        borderRadius: '0.85rem',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      }
    };

    let logo_size = 35; // defaults 35 => default;
    let margin_top = 0;
    if(bookingEngine?.logoSize){
        if(bookingEngine.logoSize.trim().toLowerCase()==="medium"){
            logo_size = 45;
            margin_top = 5;
        }else if(bookingEngine.logoSize.trim().toLowerCase()==="large"){
            logo_size = 60;
            margin_top = 10;
        }
    }

    return <div style={styles.container}>
      <header id="site_main_header" style={{...styles.header, backgroundColor: bookingEngine?.headerBg}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-2">
                {/*<div className="w-9 h-9 bg-indigo-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-200">
                <Search style={{ width: "16px", height: "16px" }} className="text-white" />
                </div>
                <span style={styles.logoText}>SkyBound</span>*/}
                {
                  bookingEngine?.showHeaderCompany ?
                  <div style={{height: "75px", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                      <div onClick={()=>{

                          // Ask before leaving checkout page
                          if(CONSTANTS.checkout_pages.app_level_checkout_status===true) {
                          let userResponse = window.confirm("Do you want to exit the checkout page?");
                          if (userResponse) {
                              //console.log("User clicked OK");
                              // Reset app level checkout status
                              CONSTANTS.checkout_pages.app_level_checkout_status=false;
                          } else {
                              //console.log("User clicked Cancel");
                              return;
                          }
                          }

                          window.location.href=`${agentDetails?.website_url}`

                      }} style={{marginLeft: -15}} className="site-logo">
                          {
                              !bookingEngine?.hideCompanyLogo &&
                              <p className="site-logo-img">
                                  <img style={{minWidth: logo_size, height: logo_size, marginTop: margin_top,
                                      borderRadius: `${bookingEngine?.headerLogoBorderRadius}%`}} 
                                      src={(_logo_url || LOGO_PLACEHOLDER)}/>
                                  {/*<i style={{color: "pink", marginRight: 10}} className="fa-solid fa-user" ></i>*/}
                              </p>
                          }
                          {
                              !bookingEngine?.hideCompanyName &&
                              <div className="site-logo-txt">
                                  <p style={{color: bookingEngine?.headerCompanyTxtColor, fontSize: 15}}>
                                      {
                                          _company_name ||
                                          "Business Name"
                                      }</p>
                              </div>
                          }
                      </div>
                  </div> : <div style={{height: "75px"}}></div>
              }
            </div>
            <nav className="hidden md:flex items-center gap-8">
                <a onClick={()=>{
                      window.__change_proct_type(PRODUCT_TYPES?.flights);
                      window.location.href="/search?product=0"
                  }} className="text-sm font-bold text-indigo-600 relative py-5" style={{color: isFlightPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                  Flights
                  {
                    (isFlightPT) &&
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 hover:text-indigo-600 rounded-full" style={{background: isFlightPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, bottom: 3}}></span>
                  }
                </a>
                <a onClick={()=>{
                      window.__change_proct_type(PRODUCT_TYPES?.stays);
                      window.location.href="/search?product=1"
                  }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: isStaysPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                  Hotels
                  {
                    (isStaysPT) &&
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 rounded-full" style={{background: isStaysPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, bottom: 3}}></span>
                  }
                </a>
                <a onClick={()=>{
                      window.__change_proct_type(PRODUCT_TYPES?.rental_cars);
                      window.location.href="/search?product=2"
                  }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: isRentalCarsPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                  Rental Car
                  {
                    (isRentalCarsPT) &&
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 rounded-full" style={{background: isRentalCarsPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, bottom: 3}}></span>  
                  }
                </a>
                <a onClick={()=>{
                      window.__change_proct_type("none");
                      window.location.href="/deals"
                  }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: false ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                  Packages
                  {
                    (false) &&
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 rounded-full" style={{background: false ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, bottom: 3}}></span>  
                  }
                </a>
                <a onClick={()=>{
                      window.__change_proct_type("none");
                      window.location.href="/deals?view_itin=true&public=true"
                  }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: false ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                  Itineraries
                  {
                    (false) &&
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 rounded-full" style={{background: false ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, bottom: 3}}></span>  
                  }
                </a>
            </nav>
          </div>
          <div style={{marginTop: 10}} className="flex items-center gap-5 relative">
            
            <div onClick={()=>{
              window.__change_proct_type("none");
                  window.location.href="/"
                }} className="flex items-center gap-3 pl-6 -border-l -border-slate-200" style={{cursor: "pointer"}}>
                <span className="-hidden -sm:block text-xs font-bold text-slate-700" style={{color: bookingEngine?.headerMenuActiveTxtColor}}>
                  Tools</span>
                <div style={{width: 30, height: 30, borderRadius: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <i style={{color: bookingEngine?.headerMenuIconColor, fontSize: 19}}
                            className="fa-solid fa-tools"></i>
                </div>
            </div>

            <div onClick={()=>{
                  window.__change_proct_type("none");
                  window.location.href="/account"
                }} className="flex items-center gap-3 pl-0 -border-l -border-slate-200" style={{cursor: "pointer"}}>
                <span className="-hidden -sm:block text-xs font-bold text-slate-700" style={{color: bookingEngine?.headerMenuActiveTxtColor}}>
                  Account</span>
                <div style={{width: 30, height: 30, borderRadius: "100%", display: "flex", justifyContent: "center", alignItems: "center"/*, backgroundColor: bookingEngine?.headerMenuIconColor*/}}>
                        <i style={{color: bookingEngine?.headerMenuIconColor, fontSize: 32}}
                            className="fa-solid fa-circle-user"></i>
                </div>
                {/*<div className="w-10 h-10 rounded-full bg-indigo-50 border-2 border-white shadow-sm flex items-center justify-center text-indigo-600 cursor-pointer hover:scale-105 transition-transform overflow-hidden">
                <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=John" alt="Avatar" />
                </div>*/}
            </div>

            {/*<button onClick={()=>setShowMobileMenu(!showMobileMenu)} style={{background: "none", border: "none"}} className="p-2 text-slate-400 md:hidden transition-all rounded-full">{/**hover:text-indigo-600 hover:bg-slate-50/}
                <i style={{color: bookingEngine?.headerMenuIconColor, fontSize: 30}}
                  className={("fa-solid "+(showMobileMenu ? "fa-times" : "fa-bars"))}></i>
            </button>*/}
            <button onClick={()=>setShowMobileMenu(!showMobileMenu)} style={{background: bookingEngine?.actionButtonsBg, border: "none", borderRadius: "100%", width: 35, height: 35, boxShadow: "1px 2px 3px rgba(0,0,0,0.33)"}} 
              className="flex justify-center items-center md:hidden transition-all rounded-full">{/**hover:text-indigo-600 hover:bg-slate-50*/}
                <i style={{color: bookingEngine?.actionButtonsIconColor, fontSize: 17}}
                  className={("fa-solid "+(showMobileMenu ? "fa-angle-up" : "fa-angle-down"))}></i>
            </button>
            {
              showMobileMenu &&
              <nav style={{backgroundColor: "white", minWidth: 200, boxShadow: "1px 2px 3px rgba(0,0,0,0.33)", padding: 20, position: "absolute", top: "100%", right: 0, borderRadius: 8}} className="items-center gap-8">
                <ul>
                    <li style={{padding: 10}}>
                      <a onClick={()=>{
                            window.__change_proct_type(PRODUCT_TYPES?.flights);
                            window.location.href="/search?product=0"
                        }} className="text-sm font-bold text-indigo-600 relative py-5" style={{color: isFlightPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                        <i style={{marginRight: 20, color: isFlightPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                          className="fa-solid fa-plane-departure"></i>
                        Flights
                      </a>
                    </li>
                    <li style={{padding: 10}}>
                      <a onClick={()=>{
                          window.__change_proct_type(PRODUCT_TYPES?.stays);
                          window.location.href="/search?product=1"
                        }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: isStaysPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                        <i style={{marginRight: 20, color: isStaysPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                          className="fa-solid fa-hotel"></i>
                        Hotels
                      </a>
                    </li>
                    <li style={{padding: 10}}>
                      <a onClick={()=>{
                            window.__change_proct_type(PRODUCT_TYPES?.rental_cars);
                            window.location.href="/search?product=2"
                        }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: isRentalCarsPT ? bookingEngine?.headerMenuActiveTxtColor : bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                        <i style={{marginRight: 20, color: isRentalCarsPT ? bookingEngine?.headerMenuActiveIconColor : bookingEngine?.headerMenuIconColor}}
                            className="fa-solid fa-car"></i>
                        Rental Car
                      </a>
                    </li>
                    <li style={{padding: 10}}>
                      <a onClick={()=>{
                        window.__change_proct_type("none");
                            window.location.href="/deals"
                        }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                        <i style={{marginRight: 20, color: bookingEngine?.headerMenuIconColor}}
                          className="fa-solid fa-box-open"></i>
                        Packages
                      </a>
                    </li>
                    <li style={{padding: 10}}>
                      <a onClick={()=>{
                        window.__change_proct_type("none");
                            window.location.href="/deals?view_itin=true&public=true"
                        }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                        <i style={{marginRight: 20, color: bookingEngine?.headerMenuIconColor}}
                          className="fa-solid fa-route"></i>
                        Itineraries
                      </a>
                    </li>
                    <li style={{padding: 10}}>
                      <a onClick={()=>{
                        window.__change_proct_type("none");
                            window.location.href="/deals?view_itin=true"
                        }} className="text-sm font-bold text-indigo-600 relative py-5 hover:text-indigo-600" style={{color: bookingEngine?.headerMenuTxtColor, cursor: "pointer"}}>
                        <i style={{marginRight: 20, color: bookingEngine?.headerMenuIconColor}}
                          className="fa-solid fa-list-check"></i>
                        Your Itineraries
                      </a>
                    </li>
                  </ul>
              </nav>
            }
          </div>
        </div>
      </header>
    </div>
}

export default Type4Header;